import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import selectOnlineOrderingLocationBySlug from 'bento-ordering/base/selectors/selectOnlineOrderingLocationBySlug';

function useLocationInformationByLocationId() {
  const { slug } = useParams();

  const onlineOrderingLocation = useSelector(
    selectOnlineOrderingLocationBySlug(slug)
  );

  return onlineOrderingLocation;
}

export default useLocationInformationByLocationId;
